import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

import { FileInput, FileInputProps } from "./FileInput";

type RhfFileInputProps = Omit<FileInputProps, "files" | "onFileChange"> & {
  name: string;
  rhfOptions?: RegisterOptions;
  className?: string;
  multiple?: boolean;
};

export const RhfFileInput = (props: RhfFileInputProps): JSX.Element => {
  const { register, formState } = useFormContext();

  register(props.name, props.rhfOptions);

  return (
    <div className={props.className}>
      <Controller
        name={props.name}
        render={({ field }) => (
          <FileInput
            {...props}
            files={field.value as File[]}
            onFileChange={field.onChange}
            multiple={props.multiple}
          />
        )}
      />

      {
        <p className="text-xs text-red-500 mt-1 ml-1">
          {formState.errors[props.name]?.message?.toString() ?? ""}
        </p>
      }
    </div>
  );
};
